module.exports = __webpack_public_path__ + "img/logo.f6106d45.png";